// src/utils/soundUtils.js
class SoundUtils {
  static sounds = {
    cardDraw: new Audio('/assets/sounds/card-draw.mp3'),
    cardPlace: new Audio('/assets/sounds/card-place.mp3'),
    turnChange: new Audio('/assets/sounds/turn-change.mp3'),
    win: new Audio('/assets/sounds/win.mp3'),
    lose: new Audio('/assets/sounds/lose.mp3'),
    error: new Audio('/assets/sounds/error.mp3'),
    buttonClick: new Audio('/assets/sounds/button-click.mp3')
  };

  static initialized = false;
  // Mute flag shared with SoundControls / the table side bar via localStorage('gameMuted')
  static muted = (() => {
    try { return localStorage.getItem('gameMuted') === 'true'; } catch (e) { return false; }
  })();

  static isMuted() {
    return this.muted;
  }

  static setMuted(muted) {
    this.muted = !!muted;
    try { localStorage.setItem('gameMuted', String(this.muted)); } catch (e) { /* ignore */ }
    if (this.muted) {
      Object.values(this.sounds).forEach(sound => { try { sound.pause(); } catch (e) { /* ignore */ } });
    }
  }

  static init() {
    if (this.initialized) return;

    // Volume is shared with SoundControls through localStorage('gameVolume')
    let vol = 0.6;
    try {
      const saved = parseFloat(localStorage.getItem('gameVolume'));
      if (!isNaN(saved)) vol = saved;
    } catch (e) { /* ignore */ }
    Object.values(this.sounds).forEach(sound => {
      sound.volume = vol;
      sound.preload = 'auto';
    });

    // Mobile browsers only let audio play after a user gesture: on the first tap, "touch" every sound
    // silently so later plays (turn change, opponent discards) are allowed without a tap.
    if (typeof window !== 'undefined' && !this._unlockBound) {
      this._unlockBound = true;
      const unlock = () => {
        Object.values(this.sounds).forEach(s => {
          // `muted` (not volume=0): iPhones ignore volume changes, so the old unlock played every
          // sound ALOUD on the first tap (that was the stray draw sound).
          s.muted = true;
          const done = () => { try { s.pause(); s.currentTime = 0; } catch (e) { /* ignore */ } s.muted = false; };
          const p = s.play();
          if (p && p.then) p.then(done).catch(() => { s.muted = false; }); else done();
        });
        window.removeEventListener('pointerdown', unlock);
        window.removeEventListener('touchend', unlock);
      };
      window.addEventListener('pointerdown', unlock);
      window.addEventListener('touchend', unlock);
    }

    this.initialized = true;
  }

  // Table sets this to false whenever the game is NOT in the playing state (point table, game over, waiting)
  static gameActive = true;
  static GAME_ONLY = ['cardDraw', 'cardPlace', 'turnChange'];

  static setGameActive(active) {
    this.gameActive = !!active;
    if (!this.gameActive) {
      this.GAME_ONLY.forEach(n => { const s = this.sounds[n]; if (s) { try { s.pause(); s.currentTime = 0; } catch (e) { /* ignore */ } } });
    }
  }

  static play(soundName) {
    this.init();
    if (this.muted) return;
    if (!this.gameActive && this.GAME_ONLY.includes(soundName)) return;   // no draw/discard/turn sounds outside play
    
    const sound = this.sounds[soundName];
    if (sound) {
      sound.currentTime = 0;
      sound.play().catch(e => console.log('Sound play failed:', e));
    }
  }

  static setVolume(volume) {
    Object.values(this.sounds).forEach(sound => {
      sound.volume = volume;
    });
  }
}

export default SoundUtils;